import React from 'react';
import reactDom from 'react-dom'

import { message } from 'antd';

import { openLoginNoCaptchaModal } from '@components/NoCaptchaModal/loginNoCaptchaModal'
import { getRemoteConfigValue } from '@utils/firebase'
import { getExecute, I18n } from '@utils/index';

import { Login } from '../Login'
import { LoginRegister } from '../LoginRegister'
import { Regsiter } from '../Regsiter'
type IParams = {
  /** 挂载登录模块的容器 */
  el: HTMLElement;
  /** tabClass */
  tabClass?: string;
  /** 支持三方登录的列表 不传则不支持  */
  oAuthList?: string[];
  /** 底部按钮 方便在H5控制样式 */
  bottomClass?: string;
  /** 登录按钮 class */
  btnClass?: string;
  /** 登录按钮文字 */
  btnText?: string;
  /** 登录成功的回调 */
  cb?: (params: any) => void;
  /** 主题 */
  theme?: Theme;
  /** 三方登录的形式 popup 弹出式 redirect 重定向式 */
  mode?: 'popup'|'redirect';
}

type IRes = {
  /** 移除登录模块 */
  unMount: () => void;
  /** 添加登录模块 */
  mount: () => void;
}

/** 初始化一个可以切换手机邮箱的登录模块 */
export const initTabLogin = (params: IParams): IRes => {
  const { el, ...rest } = params;
  const div = document.createElement('div');
  const mount = () => {
    if (el?.childNodes.length) return;
    el?.append(div);
    reactDom.render(<Login {...rest} />, div)
  }
  const unMount = () => {
    try {
      if (!el?.childNodes.length) return;
      el?.removeChild?.(div);
    } catch (error) {
    }
  }
  return {
    mount,
    unMount
  }
}

interface IRegisterParams {
  /** 挂载注册模块的容器 */
  el: HTMLElement;
  /** tabClass */
  tabClass?: string;
  /** 底部按钮 方便在H5控制样式 */
  bottomClass?: string;
  /** 注册按钮 class */
  btnClass?: string;
  /** 注册按钮文字 */
  btnText?: string;
  /** 注册成功的回调 */
  cb?: (params: any) => void;
  /** 注册成功前的勾子 */
  beforeHook?: (params: any) => void;
  /** 主题 */
  theme?: Theme;
  /** 邀请码 */
  inviteCode?: string;
  /** 邀请码模块是否展示 默认展示 */
  showInviteCode?: boolean;
  /** 验证码抽屉或弹窗形式 */
  mode?: 'modal'|'drawer';
}

/** 初始化一个可以切换手机邮箱的登录模块 */
export const initTabRegister = (params: IRegisterParams): IRes => {
  const { el, ...rest } = params;
  const div = document.createElement('div');
  const mount = () => {
    if (el?.childNodes.length) return;
    el?.append(div);
    reactDom.render(<Regsiter {...rest} />, div)
  }
  const unMount = () => {
    try {
      if (!el?.childNodes.length) return;
      el?.removeChild?.(div);
    } catch (error) {
    }
  }
  return {
    mount,
    unMount
  }
}

type IOpenLoginAndRegister = {
  /** 默认为登录 or 注册 */
  defaultType?: 'login'|'register';
  /** 主题 */
  theme?: Theme;
  /** 登录或注册完成之后的回调 */
  cb?: (params: any) => void;
}

/** 打开登录和注册抽屉 在PC表现为抽屉 在H5表现为弹窗 */
export const openLoginAndRegister = (params?: IOpenLoginAndRegister) => {
  const div = document.createElement('div');
  reactDom.render(<LoginRegister {...params} />, div)
}

/** 无痕验证、图片验证切换 */

export const verification = async (cb) => {
  try {
    const remoteConfigValue = await getRemoteConfigValue('common_switch')
    const _value = JSON.parse(remoteConfigValue.asString())
    let captchaTokenData = {}
    if (_value.noCaptchaV3 === 'true') {
      // 无痕验证
      captchaTokenData = await getExecute();
    } else {
      // 图片验证
      captchaTokenData = await openLoginNoCaptchaModal();
    }
    cb?.(captchaTokenData)
  } catch (error) {
    message.error(I18n.t('qaL3UDvo'))
  }
}
